@let aiRanOaiboxTelem =
  oaiboxTelemetry
    ? oaiboxTelemetry
    : aiRanTelemetry
      ? aiRanTelemetry
      : undefined;
<div
  class="oaibox-telemetry-item {{
    (aiRanOaiboxTelem?.status ?? OaiboxStatus.OFFLINE | oaiboxStatusConfig)
      ?.gradient
  }}"
>
  <div class="oaibox-wrapper">
    <oaibox-custom-i class="oaibox-status-icon" icon="box-inverted" iconsBasePath="assets/icons/duotone"></oaibox-custom-i>
    <div class="oaibox-details">
      <div class="oaibox-type-wrapper">
        <a
          href="{{ dashboardBasePath }}/{{ tenant.id }}{{
            machine.productDetails.oaiboxType === OaiboxType.OAIBOX_AI_RAN ||
            machine.productDetails.oaiboxType === OaiboxType.OCUDU_KIT
              ? ''
              : '/' + machine.id
          }}"
          class="oaibox-type"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ (tenant | machineConfig: machine)?.name ?? "OAIBOX" }}
          <i class="fa-solid fa-arrow-up-right-from-square primary"></i>
        </a>
        <div class="last-update">
          {{
            aiRanOaiboxTelem?.timestamp
              ? (aiRanOaiboxTelem?.timestamp
                | epochToDate
                | date: "yyyy/MM/dd HH:mm:ss")
              : "--"
          }}
        </div>
        <div class="status-description">
          {{
            (
              aiRanOaiboxTelem?.status ?? OaiboxStatus.OFFLINE
              | oaiboxStatusConfig
            )?.description
          }}
        </div>
      </div>

      <oaibox-menu class="oaibox-actions-menu">
        @if (upgradeOaiboxAction) {
          <button
            class="action-button"
            [oaiboxActionButton]="upgradeOaiboxAction"
            [sendAction]="sendAction"
            [oaiboxAuthorizedRoles]="upgradeOaiboxAction.rolesAssigned"
            [disabled]="
              !aiRanOaiboxTelem ||
              aiRanOaiboxTelem?.status === OaiboxStatus.OFFLINE
            "
          >
            <i
              class="{{ upgradeOaiboxAction.icon }} {{
                upgradeOaiboxAction.gradientColor
              }}"
            ></i>
            <span>{{ upgradeOaiboxAction.name }}</span>
          </button>
        }
        @if (upgradeUhdAction) {
          <button
            class="action-button"
            [oaiboxActionButton]="upgradeUhdAction"
            [sendAction]="sendAction"
            [oaiboxAuthorizedRoles]="upgradeUhdAction.rolesAssigned"
            [disabled]="
              !aiRanOaiboxTelem ||
              aiRanOaiboxTelem.status === OaiboxStatus.OFFLINE
            "
          >
            <i
              class="{{ upgradeUhdAction.icon }} {{
                upgradeUhdAction.gradientColor
              }}"
            ></i>
            <span>{{ upgradeUhdAction.name }}</span>
          </button>
        }
      </oaibox-menu>

      <div class="oaibox-info-wrapper">
        <div class="oaibox-info">
          <div class="oaibox-info-label">ID</div>
          <div
            class="oaibox-info-value secondary-lighter"
            [oaiboxCopy]="machine.id"
          >
            {{ machine.id }}
          </div>
        </div>
        <div class="oaibox-info">
          <div class="oaibox-info-label">SN</div>
          <div
            class="oaibox-info-value secondary-lighter"
            [oaiboxCopy]="machine.oaiboxSerialNumber"
          >
            {{ machine.oaiboxSerialNumber }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="buttons-wrapper">
    <div
      [style.visibility]="build ? 'visible' : 'hidden'"
      [oaiboxAuthorizedRoles]="[UserRole.ROOT]"
      oaiboxBsPopover="Build Details"
      trigger="hover"
      container="body"
      placement="bottom"
      class="dropdown h-100 {{
        build?.commitId === oaiboxTelemetry?.commitId ? 'success' : 'warning'
      }}"
    >
      <button
        class="management-button"
        [id]="buildDropdownToggleId"
        [attr.aria-controls]="buildDropdownId"
        data-bs-toggle="dropdown"
      >
        <i
          class="{{
            build?.commitId === oaiboxTelemetry?.commitId
              ? 'fa-regular fa-file-circle-check'
              : 'fa-regular fa-file-circle-exclamation'
          }}"
        ></i>
      </button>
      <div
        class="dropdown-menu p-g"
        [id]="buildDropdownId"
        role="menu"
        [attr.aria-labelledby]="buildDropdownToggleId"
        (click)="$event.stopPropagation()"
      >
        <oaibox-build-details
          [buildDetails]="build"
          [oaiboxTelemetry]="oaiboxTelemetry"
        ></oaibox-build-details>
      </div>
    </div>
    @if (oaiboxTelemetry) {
      <button
        [style.visibility]="
          !isRoot && availableBuildCommitDto ? 'visible' : 'hidden'
        "
        [oaiboxAuthorizedRoles]="[UserRole.RESELLER]"
        oaiboxBsPopover="{{
          availableBuildCommitDto?.commitId === oaiboxTelemetry.commitId
            ? 'Up to date'
            : 'New Build Available'
        }}"
        trigger="hover"
        container="body"
        placement="bottom"
        class="management-button {{
          availableBuildCommitDto?.commitId === oaiboxTelemetry.commitId
            ? 'success'
            : 'warning'
        }}"
      >
        <i
          class="{{
            availableBuildCommitDto?.commitId === oaiboxTelemetry.commitId
              ? 'fa-regular fa-file-circle-check'
              : 'fa-regular fa-file-circle-exclamation'
          }}"
        ></i>
      </button>
    }

    <button
      class="management-button primary"
      [oaiboxAuthorizedRoles]="[UserRole.ROOT]"
      oaiboxBsPopover="Build Executable"
      trigger="hover"
      container="body"
      placement="bottom"
      (click)="downloadBuildExecutable()"
    >
      <i class="fa-solid fa-download"></i>
    </button>

    <button
      class="management-button secondary"
      [oaiboxAuthorizedRoles]="[UserRole.ROOT]"
      oaiboxBsPopover="Update Machine Configuration"
      trigger="hover"
      container="body"
      placement="bottom"
      (click)="updateMachine()"
    >
      <i class="fa-solid fa-gear"></i>
    </button>
    <button
      class="management-button danger"
      [oaiboxAuthorizedRoles]="[UserRole.ROOT]"
      oaiboxBsPopover="Unlink Machine"
      trigger="hover"
      container="body"
      placement="bottom"
      (click)="unlinkMachine()"
    >
      <i class="fa-solid fa-link-slash"></i>
    </button>
    <button
      class="management-button danger"
      [oaiboxAuthorizedRoles]="[UserRole.ROOT]"
      oaiboxBsPopover="Delete Machine"
      trigger="hover"
      container="body"
      placement="bottom"
      (click)="deleteMachine()"
    >
      <i class="fa-solid fa-trash"></i>
    </button>
  </div>

  <div class="components-wrapper">
    @if (tenant.flexRic) {
      <div
        class="oaibox-component {{
          (flexRicTelemetry?.state ?? FlexRicState.STOPPED | flexRicStateConfig)
            ?.color
        }}"
      >
        <i class="component-status-icon square-icon fa-duotone fa-solid fa-brain-circuit"></i>

        <div class="component-status-text">
          <div>FlexRIC</div>
          <div class="component-status-description">
            {{
              (
                flexRicTelemetry?.state ?? FlexRicState.STOPPED
                | flexRicStateConfig
              )?.description
            }}
          </div>
        </div>

        @if (upgradeFlexRicAction) {
          <oaibox-menu class="component-actions-menu">
            <button
              class="action-button"
              [oaiboxActionButton]="upgradeFlexRicAction"
              [sendAction]="sendAction"
              [oaiboxAuthorizedRoles]="upgradeFlexRicAction.rolesAssigned"
              [disabled]="
                !aiRanOaiboxTelem ||
                aiRanOaiboxTelem.status === OaiboxStatus.OFFLINE
              "
            >
              <i
                class="{{ upgradeFlexRicAction.icon }} {{
                  upgradeFlexRicAction.gradientColor
                }}"
              ></i>
              <span>{{ upgradeFlexRicAction.name }}</span>
            </button>
          </oaibox-menu>
        }
      </div>
    }

    @if (machine.productDetails.oaiboxType !== OaiboxType.OAIBOX_DU) {
      <div
        class="oaibox-component {{
          (
            aiRanOaiboxTelem?.cn5gStatus ?? Cn5gStatus.STOPPED
            | cn5gStatusConfig
          )?.gradient
        }}"
      >
        <i class="component-status-icon square-icon fa-duotone fa-solid fa-chart-network"></i>

        <div class="component-status-text">
          <div>CN5G</div>
          <div class="component-status-description">
            {{
              (
                aiRanOaiboxTelem?.cn5gStatus ?? Cn5gStatus.STOPPED
                | cn5gStatusConfig
              )?.description
            }}
          </div>
        </div>

        @if (upgradeCN5GAction) {
          <oaibox-menu class="component-actions-menu">
            <button
              class="action-button"
              [oaiboxActionButton]="upgradeCN5GAction"
              [sendAction]="sendAction"
              [oaiboxAuthorizedRoles]="upgradeCN5GAction.rolesAssigned"
              [disabled]="
                !aiRanOaiboxTelem ||
                aiRanOaiboxTelem.status === OaiboxStatus.OFFLINE
              "
            >
              <i
                class="{{ upgradeCN5GAction.icon }} {{
                  upgradeCN5GAction.gradientColor
                }}"
              ></i>
              <span>{{ upgradeCN5GAction.name }}</span>
            </button>
          </oaibox-menu>
        }
      </div>
    }

    @if (
      machine.productDetails.oaiboxType !== OaiboxType.OAIBOX_CU &&
      machine.productDetails.oaiboxType !== OaiboxType.OAIBOX_AI_RAN &&
      machine.productDetails.oaiboxType !== OaiboxType.OCUDU_KIT
    ) {
      <div
        class="oaibox-component {{
          (
            oaiboxTelemetry?.gnbStatus ?? GnbStatus.GNB_STOPPED
            | gnbStatusConfig
          )?.gradient
        }}"
      >
        <i class="component-status-icon square-icon fa-duotone fa-solid fa-tower-broadcast"></i>

        <div class="component-status-text">
          <div>gNB</div>
          <div class="component-status-description">
            {{
              (
                oaiboxTelemetry?.gnbStatus ?? GnbStatus.GNB_STOPPED
                | gnbStatusConfig
              )?.description
            }}
          </div>
        </div>

        @if (upgradeGNBAction) {
          <oaibox-menu class="component-actions-menu">
            <button
              class="action-button"
              [oaiboxActionButton]="upgradeGNBAction"
              [sendAction]="sendAction"
              [actionTenantId]="tenant.id"
              [actionMachineId]="machine.id"
              [oaiboxAuthorizedRoles]="upgradeGNBAction.rolesAssigned"
              [disabled]="
                !oaiboxTelemetry ||
                oaiboxTelemetry.status === OaiboxStatus.OFFLINE
              "
            >
              <i
                class="{{ upgradeGNBAction.icon }} {{
                  upgradeGNBAction.gradientColor
                }}"
              ></i>
              <span>{{ upgradeGNBAction.name }}</span>
            </button>
          </oaibox-menu>
        }
      </div>
    } @else if (
      machine.productDetails.oaiboxType === OaiboxType.OAIBOX_AI_RAN ||
      machine.productDetails.oaiboxType === OaiboxType.OCUDU_KIT
    ) {
      @for (gnb of aiRanTelemetry?.gnbs; track gnb.id) {
        <div
          class="oaibox-component {{
            (
              gnb.component?.status ?? AiRan5GStatus.STOPPED
              | aiRan5gStatusConfig
            )?.color
          }}"
        >
          <i class="component-status-icon square-icon fa-duotone fa-solid fa-tower-broadcast"></i>

          <div class="component-status-text">
            <div>gNB</div>
            <div class="component-status-description">
              {{
                (
                  gnb.component?.status ?? AiRan5GStatus.STOPPED
                  | aiRan5gStatusConfig
                )?.description
              }}
            </div>
          </div>

          @if (upgradeGNBAction) {
            <oaibox-menu class="component-actions-menu">
              <button
                class="action-button"
                [oaiboxActionButton]="upgradeGNBAction"
                [sendAction]="sendAction"
                [actionTenantId]="tenant.id"
                [actionMachineId]="machine.id"
                [oaiboxAuthorizedRoles]="upgradeGNBAction.rolesAssigned"
                [disabled]="
                  !aiRanTelemetry ||
                  aiRanTelemetry.status === OaiboxStatus.OFFLINE
                "
              >
                <i
                  class="{{ upgradeGNBAction.icon }} {{
                    upgradeGNBAction.gradientColor
                  }}"
                ></i>
                <span>{{ upgradeGNBAction.name }}</span>
              </button>
            </oaibox-menu>
          }
        </div>
      }
    }
  </div>
</div>
